/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { toEmojiText } from '../common/community/feed/preview-html';

// Plain text with shortcodes as Unicode emoji, for aria-label and other accessible text.
@Pipe({
  name: 'emojiText',
  standalone: true,
})
export class EmojiTextPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return toEmojiText(value ?? '');
  }
}
